import React from 'react'
import { Route, Switch } from 'react-router-dom'
import './container-front.css'

// routes config
import routes from '../routes'

const TheHeader = () => {
  return (
    <Switch>
      {routes.map((route, idx) => {
        return (
          route.component && (
            <Route
              key={idx}
              path={route.path}
              exact={route.exact}
              name={route.name}
              render={(props) => (
                <div className="front-header">
                  <route.header {...props} />
                </div>
              )}
            />
          )
        )
      })}
      )
    </Switch>
  )
}

export default TheHeader
